import React, { useState, useEffect } from "react";
import axios from "axios";
import { Form, Modal, Button } from "react-bootstrap";
import { BASE_URL } from "../../../env";

// "checking" until the booking is looked up, then "booked", "notBooked" or "error".
const BOOKING_CHECKING = "checking";

const UploadBranchManagerBookingDocumentsStatic = ({
  show,
  handleConfirm,
  handleClose,
  memberId,
}) => {
  const [files, setFiles] = useState({
    ornamentPhoto: null,
    bookingReceipt: null,
    customerLivePhoto: null,
    others1: null,
    others2: null,
  });
  const [validationError, setValidationError] = useState("");
  const [bookingState, setBookingState] = useState(BOOKING_CHECKING);

  // The documents are saved onto the booking record, and the booking receipt
  // asked for here is the one the booking process prints. So the booking
  // process must be done first; until then only a warning is shown.
  useEffect(() => {
    if (!show || !memberId) return undefined;
    let cancelled = false;
    setBookingState(BOOKING_CHECKING);
    const checkBooking = async () => {
      try {
        const filter = encodeURIComponent(JSON.stringify({ memberId }));
        const response = await axios.get(
          `${BASE_URL}/api/getModelData/booking_process_bm?filter=${filter}&fields=id&includeDepth=0`
        );
        if (cancelled) return;
        setBookingState(response.data?.data?.length > 0 ? "booked" : "notBooked");
      } catch (error) {
        console.error("Error checking booking process:", error);
        if (!cancelled) setBookingState("error");
      }
    };
    checkBooking();
    return () => {
      cancelled = true;
    };
  }, [show, memberId]);

  const isBooked = bookingState === "booked";

  const handleFileChange = (fieldName) => (e) => {
    setFiles((prev) => ({ ...prev, [fieldName]: e.target.files[0] }));
  };

  const handleConfirmApprove = async (e) => {
    e.preventDefault();

    // Validate mandatory fields
    if (
      !files.ornamentPhoto ||
      !files.bookingReceipt ||
      !files.customerLivePhoto
    ) {
      setValidationError(
        "Ornament photo, booking receipt and customer live photo are required"
      );
      return;
    }

    const formData = new FormData();
    formData.append("member_id", memberId);

    // Append all files that exist
    Object.keys(files).forEach((key) => {
      if (files[key]) {
        formData.append(key, files[key]);
      }
    });

    try {
      const response = await axios.post(
        `${BASE_URL}/api/uploadBranchManagerBookingProcessDocuments`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
          withCredentials: true,
        }
      );
      console.log("Upload successful: ", response.data);
      handleConfirm();
    } catch (error) {
      console.log("Error uploading documents: ", error);
      setValidationError(
        error.response?.data?.error || "Error uploading documents: " + error.message
      );
    }
  };

  return (
    <Modal show={show} onHide={handleClose} dialogClassName="full-width-modal">
      <Modal.Header closeButton>
        <Modal.Title>Upload Booking Process Documents</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {bookingState === BOOKING_CHECKING && (
          <div className="text-center text-muted py-3">Checking the booking process...</div>
        )}
        {bookingState === "notBooked" && (
          <div className="alert alert-danger mb-0" role="alert">
            <strong>Booking process is not done for this customer.</strong>
            <div>
              First complete the booking process using the &quot;Show Booking Process&quot; button,
              then upload the booking process documents here.
            </div>
          </div>
        )}
        {bookingState === "error" && (
          <div className="alert alert-danger mb-0" role="alert">
            Could not check the booking process for this customer. Please close this window and
            try again.
          </div>
        )}
        {isBooked && validationError && (
          <div className="alert alert-danger">{validationError}</div>
        )}
        {isBooked && (
          <Form>
            <Form.Group>
              <Form.Label>Ornament Photo*</Form.Label>
              <Form.Control
                type="file"
                accept="image/*"
                onChange={handleFileChange("ornamentPhoto")}
                required
              />
            </Form.Group>
            <Form.Group>
              <Form.Label>Booking Receipt*</Form.Label>
              <Form.Control
                type="file"
                accept="image/*,application/pdf"
                onChange={handleFileChange("bookingReceipt")}
                required
              />
            </Form.Group>
            <Form.Group>
              <Form.Label>Customer Live Photo*</Form.Label>
              <Form.Control
                type="file"
                accept="image/*"
                onChange={handleFileChange("customerLivePhoto")}
                required
              />
            </Form.Group>
            <Form.Group>
              <Form.Label>Other Document 1</Form.Label>
              <Form.Control
                type="file"
                accept="image/*,application/pdf"
                onChange={handleFileChange("others1")}
              />
            </Form.Group>
            <Form.Group>
              <Form.Label>Other Document 2</Form.Label>
              <Form.Control
                type="file"
                accept="image/*,application/pdf"
                onChange={handleFileChange("others2")}
              />
            </Form.Group>
          </Form>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          {isBooked ? "Cancel" : "Close"}
        </Button>
        {isBooked && (
          <Button variant="primary" onClick={handleConfirmApprove}>
            Upload
          </Button>
        )}
      </Modal.Footer>
    </Modal>
  );
};

export default UploadBranchManagerBookingDocumentsStatic;
